<template>
  <div style='height: 100%'>
    <div v-for='iconJson in iconJsons' :key='iconJson.id'>
      <div v-for='icon in iconJson.glyphs' :key='icon.font_class' class='iconDiv'>
        <i :class='iconJson.font_family + " " + iconJson.css_prefix_text + icon.font_class' style='font-size: 80px;'/>
        <span style='font-size: 14px; padding: 0 20px; line-height: 16px;'>{{iconJson.css_prefix_text + icon.font_class}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Icon',
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      iconJsons: []
    }
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },

  created: function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    const parameterStr = that.$route.query.parameterStr
    const iconJsonNames = parameterStr.split(',')
    for (let i = 0; i < iconJsonNames.length; i++) {
      if (!iconJsonNames[i]) continue
      axios.get('/icon/' + iconJsonNames[i] + '.json').then((rtnObj) => {
        that.iconJsons.push(rtnObj.data)
      })
    }
  }
}
</script>

<style scoped>
.iconDiv {
  width: 140px;
  height: 140px;
  float: left;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: left;
}
</style>
